import { AdminManageSettingsWrapper } from "./AdminManageSettings.styles.ts";
import {
	ChangeGlobalAckSettingsText,
	ChangeManageStoreAndLeadSettingsText,
	ManageAckSettingsText,
	ManagePersonalSettingsText,
	ManageStoreAndLeadSettingsText,
	MngPrsnlChangeViewSettingsText
} from "constants/text.ts";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router";
import { MouseEvent } from "react";

interface AdminSettings {
	label: string;
	description: string;
	href: string;
}

export const adminSettings: AdminSettings[] = [
	{
		label: ManagePersonalSettingsText,
		description: MngPrsnlChangeViewSettingsText,
		href: "/admin-settings/people"
	},
	{
		label: ManageAckSettingsText,
		description: ChangeGlobalAckSettingsText,
		href: "/admin-settings/accounts"
	},
	{
		label: ManageStoreAndLeadSettingsText,
		description: ChangeManageStoreAndLeadSettingsText,
		href: "/admin-settings/stores"
	}
];

const AdminManageSettings = () => {
	const navigate = useNavigate();

	const handleClick = (e: MouseEvent<HTMLAnchorElement>, href: string) => {
		if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
			e.preventDefault();
			navigate(href);
		}
	};

	return (
		<AdminManageSettingsWrapper>
			{adminSettings.map(({ label, description, href }) => (
				<a
					key={label}
					href={href}
					data-testid={`admin-manage-settings-${label}`}
					onClick={(e) => handleClick(e, href)}
				>
					<h2>{label}</h2>
					<span>{description}</span>
					<ChevronRight />
				</a>
			))}
		</AdminManageSettingsWrapper>
	);
};

export default AdminManageSettings;
